import { api } from './client.js';

export async function login(password: string): Promise<{ token: string }> {
  return api<{ token: string }>('/auth/login', {
    method: 'POST',
    auth: false,
    body: JSON.stringify({ password }),
  });
}

export async function me(): Promise<{ userId: string }> {
  return api<{ userId: string }>('/me');
}
